/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { DocumentNode, FetchResult, MutationFunctionOptions, useMutation } from "@apollo/client";
import useCommandExecutionHandler from "../Utils/useCommandExecutionHandler";
import InputWrapper from "./../GraphQL/InputWrapper";
import ICommand from "./ICommand";

export default abstract class Command<TData, TInput> implements ICommand<TData, TInput> {
    private readonly _commandExecutionHandler;
    private readonly _commandQuery: DocumentNode;
    private readonly _mutation: (
        options?: MutationFunctionOptions<TData, InputWrapper<TInput>>
    ) => Promise<FetchResult<TData>>;

    public constructor(commandQuery: DocumentNode, refetchQueries: Array<string>, private readonly _noSnackbar: boolean = false) {
        this._commandQuery = commandQuery;
        this._commandExecutionHandler = useCommandExecutionHandler();
        this._mutation = useMutation<TData, InputWrapper<TInput>>(commandQuery, {
            awaitRefetchQueries: true,
            fetchPolicy: "no-cache",
            refetchQueries,
            onCompleted: () => {
            },
        })[0];
    }

    public abstract get name(): string;

    public get commandQuery(): DocumentNode {
        return this._commandQuery;
    }

    public get noSnackbar(): boolean {
        return this._noSnackbar;
    }

    public execute(input: TInput, noSnackbar: boolean = false): Promise<TData | undefined> {
        return this._commandExecutionHandler.execute<TData, TInput>(
            this.name,
            input,
            noSnackbar || this._noSnackbar,
            (variables) => this._mutation({ variables }));
    }
}
